import { CommodityRatesToCommodity } from "@/generated/api/prices";
import { Range } from "@/routes/stock-exchange/stock-exchange.utils";

import {
  DUMMY_OUTLOOK,
  getDummyRates,
  isMaskableCommodity,
  MaskableCommodity,
} from "../stock-exchange.dummy";
import { Strategy } from "../stock-exchange.flow";

class TrialStrategy implements Strategy {
  public isMasked(commodity: CommodityRatesToCommodity, range: Range) {
    return (
      isMaskableCommodity(commodity) &&
      (range === "last_week" || range === "last_month")
    );
  }

  public getDummyRates(commodity: MaskableCommodity, range: Range) {
    return getDummyRates(commodity, range);
  }

  public getDummyOutlook(commodity: MaskableCommodity) {
    return DUMMY_OUTLOOK[commodity];
  }

  public showCallToAction() {
    return true;
  }
}

export { TrialStrategy };
